import templateUrl from "./list-icd-corporations-container.component.html";
export const ListIcdCorporationsContainerComponent = {
    controller: ListIcdCorporationContainerController,
    controllerAs: "vm",
    templateUrl
}

function ListIcdCorporationContainerController($uibModal, $q, icdCorporationService, utilityService,
    teamService, divisionService) {
    'ngInject';
    const vm = this;

    let defaultFilter;

    vm.icdCorporations;
    vm.filters;
    vm.onChangeFilters = onChangeFilters;
    vm.onChangePage = onChangePage;
    vm.onDelete = onDelete;
    vm.sortDirection = 1; // Ascending.
    vm.$onInit = onInit;
    vm.saveFilters = saveFilters;
    const PARROLL_PROCESSOR_ROLE_ID = 20;
    vm.selectedDivisionProfiles = [];

    function onInit() {
        if (vm.isSiteAdmin) {
            defaultFilter = { Role: "Owner" };
        } else {
            defaultFilter = {};
        }

        defaultFilter.PageNumber = 1;
        defaultFilter.PageSize = 15;

        const filtersRestored = restoreFilters();
        const icdcorporationsLoaded = loadICDCorporations();
        const icdCorporationStatusLoaded = loadIcdCorporationStatus();
        const teamsLoaded = loadTeams();
        const divisionsLoaded = divisionService.retrieveDivisionProfiles()
            .then(divisionProfiles => vm.divisionProfiles = divisionProfiles.sort((a, b) => {
                if (a.DivisionName < b.DivisionName) {
                    return -1;
                } else if (a.DivisionName > b.DivisionName) {
                    return 1;
                }
                return a.Name < b.Name ? -1 : 1
            }).map(profile => ({
                ...profile,
                text: `${profile.DivisionName} (${profile.Name})`
            })));

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError($q.all([filtersRestored, icdcorporationsLoaded, icdCorporationStatusLoaded, teamsLoaded, divisionsLoaded]), "Initial load failed"));
    }

    function loadIcdCorporationStatus() {
        return icdCorporationService.retrieveIcdCorporationStatus()
            .then(function (statusOptions) {
                vm.statusOptions = statusOptions;
            });
    }

    const changeFilters = utilityService.debounce(function () {
        vm.filters.PageNumber = 1;
        saveFilters();

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(loadICDCorporations(), "Filtering failed"));
    }, 500);

    function onChangePage() {
        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(loadICDCorporations(), "Changing page failed"));

        saveFilters();
    }

    function onChangeFilters() {
        changeFilters();
    }

    function saveFilters() {
        localStorage.setItem("listIcdCorporationFilters", JSON.stringify(vm.filters || {}));
    }

    function loadICDCorporations() {
        const divProfileIds = [];
        if (vm.filters.DivisionProfiles) {
            if (vm.filters.DivisionProfiles.length > 0) {
                for (let i = 0; i < vm.filters.DivisionProfiles.length; i++) {
                    divProfileIds.push(vm.filters.DivisionProfiles[i].DivisionProfileID);
                }
            }
        }

        const query = !vm.filters ? {} : {
            IcdCId: vm.filters.Id,
            ClientName: vm.filters.ClientName,
            ClientAs: vm.filters.ClientAs,
            Owner: vm.filters.Owner,
            ADPCode: vm.filters.ADPCode,
            FEIN: vm.filters.FEIN,
            State: vm.filters.State,
            City: vm.filters.City,
            IcdCorporationStatusID: vm.filters.StatusID,
            PageSize: vm.filters.PageSize,
            NumberOfOffices: vm.filters.NumberOfOffices,
            PayrollProcessorTeamID: vm.filters.Team ? vm.filters.Team.TeamID : null,
            DivisionProfileIDs: divProfileIds
        }

        return icdCorporationService.retrieveIcdCorporationsPage(vm.filters.PageNumber - 1, query)
            .then(function (page) {
                vm.icdCorporationsPage = page;
                vm.icdCorporations = vm.icdCorporationsPage.Entities;
                utilityService.hideLoading();
            });
    }

    function onDelete(icdcorporation) {
        confirmDialog('Are you sure you want to delete this ICD Corporation?', icdcorporation);
    }


    function confirmDialog(message, icdcorporation) {
        $uibModal.open({
            template:
                '<div class="modal-body">'
                + message
                + '</div>'
                + '<div class="modal-footer">'
                + '<button class="btn btn-plain float-right" ng-click="vm.close()">No</button>'
                + '<button class="btn btn-plain float-right" ng-click="vm.deleteIcdCorporation();">Yes</button>'
                + '</div>',

            controller: function ConfirmModalController($uibModalInstance) {
                'ngInject'
                this.deleteIcdCorporation = function () {
                    utilityService.showLoading();
                    icdCorporationService.deleteIcdCorporation(icdcorporation.Id)
                        .then(function () {
                            $uibModalInstance.close();
                        })
                        .catch(function (ex) {
                            alert("Delete failed: " + utilityService.getExceptionMessage(ex))
                        })
                        .then(function () {
                            utilityService.hideLoading();
                        });
                };
                this.close = function () {
                    $uibModalInstance.dismiss();
                };
            },
            controllerAs: "vm",
            showCancelButton: true,
            windowClass: 'xx-dialog pagespinner',
            backdrop: 'static'
        });
    }

    function restoreFilters() {
        // Restore filters to the grid from localStorage, if available.
        vm.filters = JSON.parse(localStorage.getItem("listIcdCorporationFilters")) || defaultFilter;
        vm.filters.PageNumber = vm.filters.PageNumber || 1;
        vm.filters.PageSize = vm.filters.PageSize || 15;

        if (vm.filters == null) {
            vm.filters = {};
            localStorage.setItem("listIcdCorporationFilters", JSON.stringify(vm.filters));
        }
        return $q.when();
    }

    function loadTeams() {
        return teamService.retrieveTeams({
            RoleIDs: [PARROLL_PROCESSOR_ROLE_ID]
        }).then(function (teams) {
            vm.teams = teams;
            return teams;
        })
    }
}
